import { HEADER_INFO, HEADER_MEDIA } from './headerPaths';

export const STORE_BASE = '/store';


export const STORE_INFO = STORE_BASE + HEADER_INFO;
export const STORE_MEDIA = STORE_BASE + HEADER_MEDIA;
